import { SHIPPED_SHIELD_SKU } from '@/data/constants'

export const checkIsShippedShieldItem = (variant: { sku: string }) => `${variant.sku}`.includes(SHIPPED_SHIELD_SKU)

export default checkIsShippedShieldItem
